"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../hooks");
var _CetComponentsProvider = require("../../../providers/CetComponentsProvider");
const useStyles = () => {
  const {
    fontFamily,
    basicFontSize,
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccDateTimePickerStyle = (0, _react.useMemo)(() => {
    const deviceDateTimePickerProps = () => {
      const display = isMobileView ? 'block' : 'inline-block';
      const borderRadius = isMobileView ? pxToRem(6) : pxToRem(25);
      return {
        display,
        borderRadius
      };
    };
    const deviceTimeProps = () => {
      const width = isMobileView ? pxToRem(316) : 'auto';
      const margin = isMobileView ? '0 auto' : 'auto';
      return {
        width,
        margin
      };
    };
    const deviceTitleProps = () => {
      const fontSize = basicFontSize;
      const fontWeight = 'bold';
      const marginBottom = isMobileView ? 0 : pxToRem(3);
      return {
        fontSize,
        fontWeight,
        marginBottom
      };
    };
    const ccDateTimePicker = (0, _css.css)({
      fontFamily: fontFamily,
      ...deviceDateTimePickerProps()
    });
    const ccDateTimePickerAnchorBtn = (0, _css.css)({
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridAutoColumns: '1fr',
      gridAutoFlow: 'column',
      gridTemplateRows: '1fr',
      alignItems: 'center',
      justifyItems: 'center',
      alignContent: 'center',
      justifyContent: 'space-around',
      gap: '1rem',
      direction: 'ltr',
      lineHeight: 1,
      width: '100%',
      height: pxToRem(36),
      '& > *': {
        '& > div:nth-child(2)': {
          color: themeColors?.general.subText,
          whiteSpace: 'nowrap',
          lineHeight: 0.8
        }
      }
    });
    const ccDateTimePickerDateTitle = (0, _css.css)({
      ...deviceTitleProps()
    });
    const ccDateTimePickerTime = (0, _css.css)({
      marginBottom: pxToRem(3),
      marginInlineStart: pxToRem(3),
      ...deviceTimeProps()
    });
    const ccDateTimePickerTimeTitle = (0, _css.css)({
      marginInlineStart: pxToRem(11),
      ...deviceTitleProps()
    });
    return {
      ccDateTimePicker,
      ccDateTimePickerAnchorBtn,
      ccDateTimePickerDateTitle,
      ccDateTimePickerTime,
      ccDateTimePickerTimeTitle
    };
  }, [basicFontSize, fontFamily, isMobileView, pxToRem, themeColors?.general?.subText]);
  return {
    'cc-DateTimePicker': ccDateTimePickerStyle.ccDateTimePicker,
    'cc-DateTimePicker__anchor-btn': ccDateTimePickerStyle.ccDateTimePickerAnchorBtn,
    'cc-DateTimePicker__date-title': ccDateTimePickerStyle.ccDateTimePickerDateTitle,
    'cc-DateTimePicker__time': ccDateTimePickerStyle.ccDateTimePickerTime,
    'cc-DateTimePicker__time-title': ccDateTimePickerStyle.ccDateTimePickerTimeTitle
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;